import { ChannelAccountListResponse, ChannelAccountRemovalResponse, ChannelAccountSummary, ChannelConnectionCheckResponse, ChannelDiagnosticsResponse, ChannelPairingStateSchema, } from '@aeris/contracts';
import { request } from "./client.js";
export const fetchChannelAccounts = async (signal) => ChannelAccountListResponse.parse(await request('/api/v1/communication/channels', { signal })).accounts;
export const createChannelAccount = async (input) => ChannelAccountSummary.parse(await request('/api/v1/communication/channels', {
    method: 'POST',
    body: input,
}));
export const updateChannelAccount = async (id, input) => ChannelAccountSummary.parse(await request(`/api/v1/communication/channels/${id}`, {
    method: 'PATCH',
    body: input,
}));
/**
 * Apaga uma conta de canal e TUDO o que é dela (F076).
 *
 * Devolve quanto destruiu de cada coisa. A F073 tinha desenhado uma recusa
 * quando havia histórico; o dono decidiu o contrário, e estes números são o
 * que restou de defesa — a tela mostra o tamanho do que sumiu, em vez de a
 * exclusão acontecer em silêncio.
 */
export const deleteChannelAccount = async (id) => ChannelAccountRemovalResponse.parse(await request(`/api/v1/communication/channels/${id}`, { method: 'DELETE' }));
export const fetchChannelDiagnostics = async (accountId, signal) => ChannelDiagnosticsResponse.parse(await request(`/api/v1/communication/channels/${accountId}/diagnostics`, {
    signal,
}));
export const startChannelPairing = async (accountId, input) => ChannelPairingStateSchema.parse(await request(`/api/v1/communication/channels/${accountId}/pairing`, {
    method: 'POST',
    body: input,
}));
/** O QR gira; quem mostra pergunta de novo até virar "pareado". */
export const fetchChannelPairing = async (accountId, signal) => ChannelPairingStateSchema.parse(await request(`/api/v1/communication/channels/${accountId}/pairing`, {
    signal,
}));
export const checkChannelConnection = async (accountId) => ChannelConnectionCheckResponse.parse(await request(`/api/v1/communication/channels/${accountId}/check`, {
    method: 'POST',
}));
export const logoutChannelDevice = async (accountId) => ChannelAccountSummary.parse(await request(`/api/v1/communication/channels/${accountId}/logout`, {
    method: 'POST',
}));
//# sourceMappingURL=communication.js.map